import { useState, useCallback } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhoIsItForSection from './components/WhoIsItForSection';
import ManifestoSection from './components/ManifestoSection';
import ExperienceSection from './components/ExperienceSection';
import TakeHomeSection from './components/TakeHomeSection';
import SpeakersSection from './components/SpeakersSection';
import InfoAccessSection from './components/InfoSection';
import FinalBlock from './components/CTASection';
import Footer from './components/Footer';
import ApplicationForm from '@/components/feature/ApplicationForm';

export default function Home() {
  const [formOpen, setFormOpen] = useState(false);

  const handleOpenForm = useCallback(() => {
    setFormOpen(true);
  }, []);

  const handleCloseForm = useCallback(() => {
    setFormOpen(false);
  }, []);

  const handleScrollToInfo = useCallback(() => {
    const el = document.getElementById('informacoes');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <main>
      <Navbar onApplyClick={handleScrollToInfo} />
      <HeroSection onApplyClick={handleScrollToInfo} />
      <WhoIsItForSection />
      <ManifestoSection />
      <ExperienceSection />
      <TakeHomeSection />
      <SpeakersSection />
      <InfoAccessSection />
      <FinalBlock onApplyClick={handleOpenForm} />
      <Footer />
      <ApplicationForm isOpen={formOpen} onClose={handleCloseForm} />
    </main>
  );
}